var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.isInited)?_c('iframe',{staticClass:"viewer",attrs:{"src":_vm.viewUrl}}):_vm._e(),(!_vm.isInited)?_c('div',{staticClass:"mask"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }